module.exports = __webpack_public_path__ + "static/img/2_03.6a93bb4d.jpg";